import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useFormik } from 'formik'
// import * as Yup from 'yup'
import CustomButton from "../../components/CustomButton";
import useCustomStyles from "../../hooks/useCustomStyles";
// import { selectTranslationState } from '../../store/slices/languageSlice'
import { selectState } from "../../store/slices/themeSlice";
import { AppDispatch, RootState } from "../../store/store";
import {
  AccessCodeType,
  ContractType,
  getBusinesses,
} from "../../store/actions/accessCodeActions";
import TableComponent from "../clients/components/fff";
import { REFERRAL_CODE_COLUMNS, withDescriptions } from "../../utils/columnDescriptions";
import { ClientType } from "../../store/slices/clientsSlice";
import { accessCodesStyles } from "../../assets/styles/accessCodesStyles";
import { selectAccessCodeState } from "../../store/slices/accessCodeSlice";
import { useNavigate } from "react-router-dom";
import { ErrorTriage } from "../../api/awsApis";

export interface ContractFormType {
  business_client: string | undefined;
  contract_ref: string | undefined;
  useLimit: number | undefined;
  expire_at: string | Date | undefined;
  id?: string | undefined;
}

const ReferralsCodes: React.FC = () => {
  const { theme } = useSelector(selectState);
  const { accessCodes } = useSelector(selectAccessCodeState);
  const { businesses } = useSelector(
    (state: RootState) => state.accessCode_slice
  );
  const [referralCodes, setReferralCodes] = useState<AccessCodeType[]>([]);
  const navigate = useNavigate();

  const classes = useCustomStyles(accessCodesStyles, theme);
  const dispatch = useDispatch<AppDispatch>();

  const handleGetBusinesses = () => {
    dispatch(getBusinesses({ type: "" }));
  };

  useEffect(() => {
    if (!businesses) {
      handleGetBusinesses();
    }
  }, []);

  // Validation schema using Yup
  // const validationSchema = Yup.object({
  //   contract_ref: Yup.string().required('Contract reference is required'),
  //   business_client: Yup.string().required('Please select a business client'),
  //   useLimit: Yup.number()
  //     .required('Use limit is required')
  //     .min(1, 'Use limit must be at least 1'),
  //   expire_at: Yup.date().required('Expiry date is required'),
  // })

  // Initialize Formik
  // const formik = useFormik<ContractFormType>({
  //   initialValues: {
  //     business_client: '', // initial value for business client select
  //     contract_ref: '',
  //     useLimit: 1,
  //     expire_at: undefined,
  //     id: undefined,
  //   },
  //   validationSchema,
  //   onSubmit: (values) => {
  //     // Dispatch your code generation action here if needed
  //     dispatch(addContract(values))
  //   },
  // })

  // Wrapper function to handle form submission from button click
  // const handleFormSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   event.preventDefault();
  //   formik.handleSubmit(); // Trigger formik form submission
  // };

  ////
  // const tabs = [
  //   { value: "white_labeling", label: "White Labeling" },
  //   { value: "referrals", label: "Referrals" },
  // ];
  // const contracts = useSelector(
  //   (state: RootState) => state.accessCode_slice.contracts
  // );

  const dropdowns = [
    {
      options: [
        { value: "bassam", key: "1" },
        { value: "hamz", key: "2" },
        { value: "ali", key: "3" },
        { value: "mohammed", key: "4" },
      ],
      initialState: "Type",
    },
    {
      options: [
        { value: "Admin", key: "1" },
        { value: "User", key: "2" },
        { value: "Guest", key: "3" },
      ],
      initialState: "Role",
    },
  ];

  useEffect(() => {
    if (accessCodes) {
      setReferralCodes(
        accessCodes.filter((code) => code.codeType === "referral-code")
      );
    }
  }, [accessCodes]);

  const columnsBySelectedTab = [
    { key: "prefix", label: "Tag /Campaign", sortable: true },
    { key: "useLimit", label: "Use Limit", sortable: false },
    { key: "useCount", label: "Used", sortable: false },
    { key: "expire_at", label: "Expiry Date", sortable: true },
    { key: "status", label: "Status", sortable: false },
  ];
  const handleClientClick = (
    contract: ClientType | ContractType | ErrorTriage
  ) => {
    navigate(`/referralCodeDetails`, { state: { contract } });
    // console.log(JSON.stringify(contract));
  };

  return (
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        <h2 className={classes.header}>REFERRAL CODES</h2>

        <div className={classes.buttonContainer}>
          <CustomButton
            title={"Create Referral Code"}
            handleClick={() => console.log("hello")}
            name={"Create-Referral-Code"}
            loading={false}
          />
        </div>
      </div>

      <TableComponent
        dropdowns={dropdowns}
        columns={withDescriptions(columnsBySelectedTab, REFERRAL_CODE_COLUMNS)}
        data={referralCodes}
        handleNavigate={handleClientClick}
      />

      {/* Display Generated Code */}
      {/*formik.values.code && <p>Your generated code: {formik.values.code}</p>*/}
    </div>
  );
};

export default ReferralsCodes;
